import React from 'react';
import { CatalogPageTypes, Nullable } from '@lerna-core';

export const PageNameContext =
  React.createContext<Nullable<CatalogPageTypes>>(null);
